import { useQuery, keepPreviousData } from "@tanstack/react-query";
import { useAxios } from "@/app/providers/AxiosProvider";
import { resolveRange } from "@/lib/settings/dateRanges";
import handleError from "../helpers/handleError";
import { DASHBOARD_FOCUS } from "@lib/enums";

function useRangeQuery(api, scope, range, focus, enabled) {
  const resolved = resolveRange(range);
  const { data, error, isLoading, isFetching } = useQuery({
    queryKey: ["team-stats", scope, focus, resolved?.from, resolved?.to],
    queryFn: () =>
      api.get("/dashboard/team", {
        params: { from: resolved.from, to: resolved.to, focus },
      }),
    enabled: Boolean(enabled && resolved),
    placeholderData: keepPreviousData,
  });

  handleError(error);

  return { data, isLoading, isFetching };
}

export default function useTeamStats({
  statsRange,
  chartRange,
  tableRange,
  focus = DASHBOARD_FOCUS.FLOATS,
  enabled = true,
} = {}) {
  const api = useAxios();

  const fixed = useRangeQuery(api, "fixed", statsRange, focus, enabled);
  const chart = useRangeQuery(api, "chart", chartRange, focus, enabled);
  const table = useRangeQuery(api, "table", tableRange, focus, enabled);

  return {
    fixedStats: fixed.data?.data?.range ?? null,
    chartStats: chart.data?.data?.range ?? null,
    tableStats: table.data?.data?.range ?? null,
    fixedLoading: fixed.isFetching,
    chartLoading: chart.isFetching,
    tableLoading: table.isFetching,
  };
}
